import { FC } from 'react'
import { SvgProps } from './svgProps'

const SweatshirtIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 25}
    height={height || 32}
    viewBox="0 0 25 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M20.84 15.018c-0.171-0.763-0.692-1.376-1.381-1.672l-0.015-0.006-3.356-1.407h-0.109c0.866-0.977 1.541-2.192 1.541-3.603-0.004-3.926-2.355-7.911-5.256-7.911s-5.243 3.985-5.243 7.919c0 1.411 0.675 2.626 1.542 3.603h-0.107l-3.356 1.407c-0.705 0.302-1.226 0.915-1.394 1.662l-0.003 0.016-3.284 14.631 3.205 0.891 2.496-9.996v11.029h12.288v-11.029l2.498 9.998 3.213-0.893z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M15.413 8.089c0 2.684-3.146 4.327-3.146 4.327s-3.146-1.642-3.146-4.327 1.409-5.398 3.146-5.398 3.146 2.712 3.146 5.398z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M6.12 24.156c0.131-0.023 0.282-0.036 0.436-0.036 0.378 0 0.738 0.080 1.064 0.223l-0.017-0.007c1.439 0.629 2.015 2.45 1.286 4.060-0.481 1.107-1.523 1.888-2.757 1.987l-0.012 0.001"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M18.42 24.156c-0.131-0.023-0.282-0.036-0.436-0.036-0.378 0-0.738 0.080-1.064 0.223l0.017-0.007c-1.441 0.629-2.015 2.45-1.286 4.060 0.48 1.107 1.521 1.888 2.755 1.987l0.012 0.001"
    ></path>
  </svg>
)

export default SweatshirtIcon
